import { render, staticRenderFns } from "./viewWorkOrders.vue?vue&type=template&id=c90120b6&"
import script from "./viewWorkOrders.vue?vue&type=script&lang=js&"
export * from "./viewWorkOrders.vue?vue&type=script&lang=js&"
import style0 from "./viewWorkOrders.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDivider,VRow})
